import React from 'react';
import { ReferenceLine, ReferenceDot } from 'recharts';
import AnimatedReferenceArea from './AnimatedReferenceArea';

export default function ChartAnnotations({ 
  data, 
  prices, 
  lastPrice, 
  minY, 
  maxY, 
  hoverY,
  onAreaClick 
}) {
  return (
    <>
      {/* 动画参考区域 */}
      <g>
        <AnimatedReferenceArea
          show={hoverY !== null}
          minY={minY}
          maxY={maxY}
          onAreaClick={onAreaClick}
        />
      </g>
      
      {/* 分界线 */}
      {lastPrice !== undefined && (
        <ReferenceLine 
          y={lastPrice} 
          stroke="#fff" 
          strokeDasharray="3 3" 
          strokeOpacity={0.5} 
        />
      )}
      
      {/* 最高点 */}
      {(() => {
        const maxPrice = Math.max(...prices);
        const maxPoint = data.find(d => d.price === maxPrice);
        const threshold = data.length * 0.8;
        const labelPosition = data.findIndex(d => d.price === maxPrice) > threshold ? 'left' : 'right';
        
        return (
          <ReferenceDot
            x={maxPoint?.time}
            y={maxPrice}
            r={3}
            fill="#fbbf24"
            stroke="#fff"
            strokeWidth={2}
            isFront={true}
            label={{
              position: 'top',
              value: `${maxPrice.toLocaleString()}`,
              fill: '#fbbf24',
              fontSize: 12,
              fontWeight: 600
            }}
            ifOverflow="visible"
          />
        );
      })()}
      
      {/* 最低点 */}
      <ReferenceDot
        x={data.find(d => d.price === Math.min(...prices))?.time}
        y={Math.min(...prices)}
        r={3}
        fill="#38bdf8"
        stroke="#fff"
        strokeWidth={2}
        isFront={true}
        label={{
          position: 'bottom',
          value: `${Math.min(...prices).toLocaleString()}`,
          fill: '#38bdf8',
          fontSize: 12,
          fontWeight: 600
        }}
        ifOverflow="visible"
      />
    </>
  );
}
